import React from 'react'
import Script from 'gatsby-theme-tailwindui/src/components/script/script'

function SanityScript(props) {
  return <Script scriptURL={props.url} />
}

export default SanityScript
